import { addTrack } from './utilidades/trackEventos';
import { loadBotao } from './utilidades/loadBotao';
import { loadFullPage } from './utilidades/loadFullPage';
import { obterQueryString } from './utilidades/obterQueryString';
import { toastErroCarregar } from './utilidades/toastErroCarregar';
import { toastSucesso } from './utilidades/toastSucesso';
import { tooglePassword } from './utilidades/tooglePassword';
import { isNullOrEmpty } from './utilidades/isNullOrEmpty';
import { salvarCandidaturaPendente, obterCandidaturaPendente } from './utilidades/candidaturaPendente';
import { getGeoData } from './utilidades/geoData';
import { removeCacheUsuarioLogado } from './utilidades/usuarioLogado';

import JustValidate from 'just-validate';
import i18next from 'i18next';
import { linkedinLogin } from './componentes/linkedinLogin';
import { googleLogin } from './componentes/googleLogin';

export const login = async () => {

    let geoData;
    let provedorExterno;
    let provedorToken;
    let provedorUsuario;

    const _selecionaVariasPessoas = function (pessoaID) {
        let $formLogin = document.getElementById('form-login');
        let $modalVariasPessoas = document.getElementById('selecionar-varias-pessoas');

        $formLogin.querySelector('#pessoaID').value = pessoaID;
        $modalVariasPessoas.classList.add('d-none');
        _autenticar($formLogin);
    };

    const _montarModalVariasPessoas = function (arrayPessoas, functionSelecionar) {
        var html = [];

        var $modalVariasPessoas = document.getElementById('selecionar-varias-pessoas');

        html.push('<div class="list-group">');
        for (var i = 0; i < arrayPessoas.length; i++) {

            html.push('<a href="javascript:void(0)" class="list-group-item d-flex gap-2 align-items-center" data-id="' + arrayPessoas[i].ID + '">');

            html.push('<div class="container-foto-pessoa" data-id=""> ');
            if (!arrayPessoas[i].Foto || arrayPessoas[i].Foto.trim() === "") {
                html.push('<img class="img-rounded img-offline" style="max-width: 32px; border-radius: 50%;" src="https://storage.empregare.com/pessoas/sem-foto.png" />');
            } else {
                html.push('<img class="img-rounded img-offline" style="max-width: 32px; border-radius: 50%;" src="https://storage.empregare.com/pessoas/' + arrayPessoas[i].Foto + '" />');
            }
            html.push('</div>');

            html.push('<div class="container-cpf-idexterno" data-id=""> ');
            html.push('<div class="nome-pessoa" data-id="' + arrayPessoas[i].ID + '">' + arrayPessoas[i].Nome + '</div>');

            if (arrayPessoas[i].Cpf && arrayPessoas[i].Cpf.trim() !== "") {
                html.push('<small class="text-muted" data-id="">' + arrayPessoas[i].Cpf + '</small>');

            } else if (arrayPessoas[i].IDExterno && arrayPessoas[i].IDExterno.trim() !== "") {
                html.push('<small class="text-muted" data-id="">' + arrayPessoas[i].IDExterno + '</small>');

            }
            html.push('</div>');

            html.push('<div class="clearfix"></div>');

            html.push('</a>');
        }
        html.push('</div>');
        $modalVariasPessoas.querySelector('.list-group').innerHTML = html.join('');

        Array.from($modalVariasPessoas.querySelectorAll('.list-group-item')).forEach((button) => {

            button.addEventListener('click', (e) => {
                let pessoaID = e.currentTarget.getAttribute('data-id');
                functionSelecionar(pessoaID);
            });
        });


        $modalVariasPessoas.classList.remove('d-none');
    };

    const _autenticar = async function (form) {

        const botaoAcessar = form.querySelector('#btn-login-acessar');
        loadBotao.mostrar(botaoAcessar);



        let returnUrl = obterQueryString().ReturnUrl;
        if (document.getElementById('vaga-detalhes-container')) {
            returnUrl = window.location.pathname + '?confirmar=1';
        }

        let timeZone = '';

        try {
            if (geoData.existe) {
                timeZone = geoData.data.timezone;
            } else {
                timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            }
        } catch (e) { }

        let formData = new FormData(form);
        formData.append('ReturnUrl', returnUrl);
        formData.append('TimeZone', timeZone);

        if (provedorExterno != null && provedorUsuario != null && provedorToken != null) {
            formData.append('ProvedorExterno', provedorExterno);
            formData.append('Usuario', provedorUsuario);
            formData.append('TokenProvedorExterno', provedorToken);
        }

        const retorno = await fetch(`/${CULTURE_EMPREGARE}/Login/Autenticar`, {
            method: 'POST',
            body: formData,
        });

        if (retorno.status != 200) {
            addTrack('Login Request Erro', { statusCode: retorno.status });
            toastErroCarregar(i18next.t('LoginErro'));
            loadBotao.esconder(botaoAcessar);
            return;
        }

        const resultados = await retorno.json();

        if (!resultados.Sucesso) {

            loadBotao.esconder(botaoAcessar);
            form.querySelector('#pessoaID').value = '';

            if (resultados.Pessoas != null) {
                _montarModalVariasPessoas(resultados.Pessoas, _selecionaVariasPessoas);
                return false;
            }

            addTrack('Login Invalido', { mensagem: resultados.Mensagem, erro: resultados.Erro });
            toastErroCarregar(resultados.Mensagem);

            let rowErro = form.querySelector('.row-erro');
            rowErro.classList.remove('d-none');
            rowErro.innerHTML = `<h4 class="fs-5">${resultados.Mensagem}</h4>${resultados.ErroDescricao}`;


            return;
        }

        addTrack('Login Valido');

        let redirect = resultados.Redirect;

        if (document.getElementById('vaga-detalhes-container')) {
            const vagaID = document.getElementById('VagaID').value;
            const vagaTitulo = document.getElementById('VagaTitulo').value;
            const vagaUrl = document.getElementById('VagaURL').value;
            await salvarCandidaturaPendente(vagaID, vagaTitulo, vagaUrl, true);
        } else {
            const candidaturaPendente = obterCandidaturaPendente();
            if (candidaturaPendente.vagaID != '0') {
                await salvarCandidaturaPendente(candidaturaPendente.vagaID, candidaturaPendente.titulo, candidaturaPendente.url, true);

                redirect = candidaturaPendente.url + '?confirmar=1';
            }
        }

        window.location.href = redirect;
    };



    const _configLogin = function (element, callbackModal) {

        geoData = getGeoData();
        removeCacheUsuarioLogado();

        let $formLogin = document.getElementById('form-login');
        let $formLoginEmpresa = document.getElementById('form-login-empresa');

        const validarLoginCandidato = new JustValidate($formLogin, {
            errorFieldCssClass: "input-senha-nao-valido",
        });
        const validarLoginEmpresa = new JustValidate($formLoginEmpresa, {
            errorFieldCssClass: "input-senha-nao-valido",
        });

        validarLoginCandidato
            .addField("#loginEmail", [{ rule: "required", errorMessage: i18next.t('ValidacaoLoginCandidatoCpfOuEmail') },])
            .addField("#loginSenha", [{ rule: "required", errorMessage: i18next.t('ValidacaoLoginSenha') }]);

        validarLoginEmpresa
            .addField("#loginEmailCompany", [
                { rule: "required", errorMessage: i18next.t('ValidacaoLoginEmpresaEmailObrigatorio') },
                {
                    rule: "email",
                    errorMessage: i18next.t('ValidacaoLoginEmpresaEmailInvalido'),
                },
            ])
            .addField("#loginSenhaCompany", [{ rule: "required", errorMessage: i18next.t('ValidacaoLoginSenha') }]);


        tooglePassword($formLogin.querySelector('#loginSenha'), $formLogin.querySelector('#senhaCandidatoIcon'));
        tooglePassword($formLoginEmpresa.querySelector('#loginSenhaCompany'), $formLoginEmpresa.querySelector('#senhaEmpresaIcon'));



        $formLogin.addEventListener("submit", (e) => {
            if ($formLogin.querySelector('.row-erro')) {
                $formLogin.querySelector('.row-erro').classList.add('d-none');
            }
            validarLoginCandidato.revalidate().then((isValid) => {
                if (isValid) {
                    _autenticar(e.target);
                }
            });
            e.preventDefault();
        });

        $formLoginEmpresa.addEventListener("submit", (e) => {
            validarLoginEmpresa.revalidate().then((isValid) => {
                if (isValid) {
                    e.target.submit();
                }
            });
        });
        element.querySelector('.cancelar-varias-pessoas').addEventListener("click", (e) => {
            document.getElementById('selecionar-varias-pessoas').classList.add('d-none');
            document.getElementById('form-login').querySelector('#pessoaID').value = '';
        });

        const popoverTrigger = document.querySelector('#acionar-popover');

        if (popoverTrigger) {
            const popover = new bootstrap.Popover(popoverTrigger);

            popoverTrigger.addEventListener("click", () => {
                popover.toggle();
            });
        }


        let qSCpf = obterQueryString().cpf;
        let qSVinculo = obterQueryString().vinculo;
        let qSTipoLogin = obterQueryString().tipo;
        if (!isNullOrEmpty(qSCpf)) {
            $formLogin.querySelector('#loginEmail').value = qSCpf;
            $formLogin.querySelector('#loginSenha').focus;
        }

        if (!isNullOrEmpty(qSVinculo)) {
            $formLogin.querySelector('#nao-tenho-cadastro').classList.add('d-none');
            $formLogin.querySelector('#vinculo').value = qSVinculo;
        } else {
            $formLogin.querySelector('#vinculo').value = '';
        }
        if (qSTipoLogin == 'empresa') {
            element.querySelector('#empresa-tab').click();
        }

        if (document.getElementById('vaga-detalhes-container')) {

            const vagaID = document.getElementById('VagaID').value;
            const vagaTitulo = document.getElementById('VagaTitulo').value;
            const vagaUrl = document.getElementById('VagaURL').value;
            salvarCandidaturaPendente(vagaID, vagaTitulo, vagaUrl, false);

            document.getElementById('tabs-login').classList.add('d-none');
        }

        //botao-google-login

        // Inicializa o Popover do Bootstrap
        const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-toggle="popover"]'));
        popoverTriggerList.map(function (popoverTriggerEl) {
            return new bootstrap.Popover(popoverTriggerEl);
        });

        linkedinLogin.init();
        googleLogin.init();


        callbackModal(element);

        loadFullPage.esconder();
    };

    function fetchHtml(callback) {
        fetch(`/${CULTURE_EMPREGARE}/Login/ModalLogin`, { cache: 'no-cache' })
            .then((response) => {
                return response.text();
            })
            .then((html) => {
                // console.log(html);
                callback(html);
                // document.body.innerHTML = html
            });
    };

    const abrirModal = async function (callbackModalAbriu = null) {

        //const { loadBotao, loadFullPage, obterQueryString, toastErroCarregar } = await import('./utilidades');
        //const { JustValidate } = await import('just-validate');

        loadFullPage.mostrar();

        function callbackModalLogin(htmlModal) {

            let modalLogin = document.getElementById('modalLogin');

            modalLogin.innerHTML = htmlModal;

            _configLogin(modalLogin, function (element) {
                const abreModal = new bootstrap.Modal(element, {});
                document.dispatchEvent(new CustomEvent('renderizarBotaoGoogleLogin'));
                abreModal.show();
                if (callbackModalAbriu != null) {
                    callbackModalAbriu();
                }
            });
        }
        fetchHtml(callbackModalLogin);


    };

    const handleAbrirModalPessoas = async function (responseCallback, provedor, response) {
        provedorUsuario = responseCallback.Usuario;
        provedorExterno = responseCallback.ProvedorExterno;
        provedorToken = response.credential;
        if (provedor === 'Google') {

            // Verifica se o modal já está aberto antes de abrir de novo
            let modalLogin = document.getElementById('modalLogin');
            if (modalLogin && !modalLogin.classList.contains('show')) {
                await abrirModal(() => {
                    _montarModalVariasPessoas(responseCallback.Pessoas, _selecionaVariasPessoas);
                });
            } else {
                _montarModalVariasPessoas(responseCallback.Pessoas, _selecionaVariasPessoas);
            }
        } else {
            _montarModalVariasPessoas(responseCallback.Pessoas, _selecionaVariasPessoas);
        }
    }

    const validarLoginExterno = async function (provedor, urlValidacao, event) {
        try {
            loadFullPage.mostrar();

            let returnUrl = obterQueryString().ReturnUrl;
            const dentroDaVaga = document.getElementById('vaga-detalhes-container');
            if (dentroDaVaga) {
                returnUrl = window.location.pathname + '?confirmar=1'
            }

            let timeZone = '';
            try {
                if (geoData.existe) {
                    timeZone = geoData.data.timezone;
                } else {
                    timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                }
            } catch (e) { }

            const { response } = event.detail;

            const request = await fetch(urlValidacao, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ credential: response.credential, returnUrl: returnUrl, timeZone: timeZone })
            });

            loadFullPage.esconder();

            if (!request.ok) {
                toastErroCarregar(i18next.t('LoginErro'));
                return;
            }

            const responseCallback = await request.json();

            if (responseCallback.Erro && responseCallback.Erro != '0' && responseCallback.ErroDescricao) {
                toastErroCarregar(i18next.t('LoginErro'));
                return;
            }
            else if (responseCallback.Pessoas != null) {
                await handleAbrirModalPessoas(responseCallback, provedor, response)
            }
            else if (responseCallback.Redirect) {
                window.location.href = responseCallback.Redirect
            }
            else if (provedor === 'LinkedIn' && (responseCallback.Sucesso || responseCallback.NaoTemCadastro)) {
                window.location.href = responseCallback.Redirect;
            }

            if (dentroDaVaga) {
                const vagaID = document.getElementById('VagaID').value;
                const vagaTitulo = document.getElementById('VagaTitulo').value;
                const vagaUrl = document.getElementById('VagaURL').value;
                const vagaStatus = document.getElementById('VagaStatus').value;

                if (provedor === 'Google') {
                    document.dispatchEvent(new CustomEvent(`googleLoginLogadoDentroDaVaga`, { detail: { vagaID, vagaTitulo, vagaUrl, vagaStatus } }));
                } else {
                    document.dispatchEvent(new CustomEvent(`linkedinLoginLogadoDentroDaVaga`, { detail: { vagaID, vagaTitulo, vagaUrl, vagaStatus } }));
                }
            }

        } catch (error) {
            loadFullPage.esconder();
            console.log(`Erro no fluxo de validação do ${provedor}`, error);
            toastErroCarregar(i18next.t('LoginErro'));
        }
    };

    const init = function () {


        const btnLogin = document.getElementsByClassName('btn-login');
        for (const btnLoginTopo of btnLogin) {
            btnLoginTopo.addEventListener("click", (e) => {
                abrirModal();
                e.preventDefault();
            });
        }
        const $contentLogin = document.getElementById('content-login');

        if (document.contains($contentLogin)) {
            loadFullPage.mostrar();
            _configLogin($contentLogin, function () { });
        }

        document.addEventListener('googleLoginResposta', async (e) => {
            const url = `/${CULTURE_EMPREGARE}/Login/GoogleLoginValidate`;
            await validarLoginExterno('Google', url, e);
        });

        document.addEventListener('linkedinLoginResposta', async (e) => {
            const url = `/${CULTURE_EMPREGARE}/Login/LinkedinLoginValidate`;
            await validarLoginExterno('LinkedIn', url, e);
        });
    };

    return init();
}